// Packages
import React from "react";
import { useController } from "react-hook-form";
import PropTypes from "prop-types";

// Components
import AutocompleteMultiField from "../AutocompleteMultiField";

const AutocompleteMultiFieldControlled = (props) => {
  const { id, name, label, control, tooltipTitle, options, handleInputChange, disabled, onKeyUp, onChangeValue } = props;

  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  const auxOnChange = (value, data) => {
    onChange(data);
    onChangeValue && onChangeValue(data)
  };
  return (
    <AutocompleteMultiField
      error={error}
      id={id}
      name={name}
      label={label}
      tooltipTitle={tooltipTitle}
      onChange={auxOnChange}
      selectedValue={value}
      options={options}
      handleInputChange={handleInputChange}
      onKeyUp={onKeyUp}
      disabled={disabled}
    />
  );
};

AutocompleteMultiFieldControlled.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  tooltipTitle: PropTypes.string,
  control: PropTypes.object.isRequired,
};

export default AutocompleteMultiFieldControlled;
